export default __webpack_public_path__ + "static/media/mustard.e750f7b0.svg";